<template>
<!-- 業務報告書エラーメッセージ -->
<div>
  <p style="color: red;" v-for="error in taskEmpty" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in planDayEmpty" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in planDayRegex" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in progressEmpty" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in progressRegex" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in planStartEmpty" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in planStartRegex" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in startDayEmpty" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in startDayRegex" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in planEndEmpty" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in planEndRegex" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in endDayRegex" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in endDayEmpty" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in detailsEmpty" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in problemEmpty" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in causeEmpty" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in measureEmpty" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in totalTimeEmpty" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in totalTimeRegex" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in definedEmpty" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in definedRegex" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in expectOverEmpty" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in expectOverRegex" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in totalOverEmpty" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in totalOverRegex" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in totalNightEmpty" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in totalNightRegex" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in totalHolidayEmpty" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in totalHolidayRegex" :key="error">{{ '※' + error }}</p>
  <p style="color: red;" v-for="error in overReasonEmpty" :key="error">{{ '※' + error }}</p>
</div>
</template>

<script>
export default {
  name: 'ReportError',
  data() {
    return {
      taskEmpty: [],
      planDayEmpty: [],
      planDayRegex: [],
      progressEmpty: [],
      progressRegex: [],
      planStartEmpty: [],
      planStartRegex: [],
      startDayEmpty: [],
      startDayRegex: [],
      planEndEmpty: [],
      planEndRegex: [],
      endDayRegex: [],
      endDayEmpty: [],
      detailsEmpty: [],
      problemEmpty: [],
      causeEmpty: [],
      measureEmpty: [],
      totalTimeEmpty: [],
      totalTimeRegex: [],
      definedEmpty: [],
      definedRegex: [],
      expectOverEmpty: [],
      expectOverRegex: [],
      totalOverEmpty: [],
      totalOverRegex: [],
      totalNightEmpty: [],
      totalNightRegex: [],
      totalHolidayEmpty: [],
      totalHolidayRegex: [],
      overReasonEmpty: []
    }
  },
  props: {
    task: Array,
    plan_day: Array,
    progress: Array,
    plan_start: Array,
    start_day: Array,
    plan_end: Array,
    end_day: Array,
    details: String,
    problem: String,
    cause: String,
    measures: String,
    total_time: String,
    defined: String,
    expect_over: String,
    total_over: String,
    total_night: String,
    total_holiday: String,
    over_reason: String
  },
  methods: {
    // 項目の空文字チェック
    task_empty: function () {
      let error = this.taskEmpty
      this.task.forEach((value, i, array) => {
        if (((this.plan_day[i] !== "") || (this.progress[i] !== "") || (this.plan_start[i] !== "") || (this.start_day[i] !== "") || (this.plan_end[i] !== "") || (this.end_day[i] !== "")) && (array[i] === "")) {
          error.splice(i, 1, i + 1 + 'つ目の項目を入力してください ')
          let set = Array.from(new Set(error))
          error = set
        } else {
          error.splice(i, 1)
        }
      })
    },
    // 予定日数の空文字チェック
    plan_day_empty: function () {
      let error = this.planDayEmpty
      this.plan_day.forEach((value, i, array) => {
        if (((this.task[i] !== "") || (this.progress[i] !== "") || (this.plan_start[i] !== "") || (this.start_day[i] !== "") || (this.plan_end[i] !== "") || (this.end_day[i] !== "")) && (array[i] === "")) {
          error.splice(i, 1, i + 1 + 'つ目の予定日数を入力してください ')
          let set = Array.from(new Set(error))
          error = set
        } else {
          error.splice(i, 1)
        }
      })
    },
    // 予定日数の入力形式チェック
    plan_day_regex: function () {
      let error = this.planDayRegex
      this.plan_day.forEach((value, i) => {
        if ((value !== "") && (!value.match(/^[0-9]*$/))) {
          error.splice(i, 1, i + 1 + 'つ目の予定日数は数字で入力してください ')
          let set = Array.from(new Set(error))
          error = set
        } else {
          error.splice(i, 1)
        }
      })
    },
    // 進捗率の空文字チェック
    progress_empty: function () {
      let error = this.progressEmpty
      this.progress.forEach((value, i, array) => {
        if (((this.task[i] !== "") || (this.plan_day[i] !== "") || (this.plan_start[i] !== "") || (this.start_day[i] !== "") || (this.plan_end[i] !== "") || (this.end_day[i] !== "")) && (array[i] === "")) {
          error.splice(i, 1, i + 1 + 'つ目の進捗率を入力してください ')
          let set = Array.from(new Set(error))
          error = set
        } else {
          error.splice(i, 1)
        }
      })
    },
    // 進捗率の入力形式チェック
    progress_regex: function () {
      let error = this.progressRegex
      this.progress.forEach((value, i) => {
        if ((value !== "") && (!value.match(/^[0-9]*$/))) {
          error.splice(i, 1, i + 1 + 'つ目の進捗率は半角整数で入力してください ')
          let set = Array.from(new Set(error))
          error = set
        } else {
          error.splice(i, 1)
        }
        if ((value.match(/^[0-9]*$/)) && (value > 100)) {
          error.splice(i, 1, i + 1 + 'つ目の進捗率は100以内で入力してください ')
          let set = Array.from(new Set(error))
          error = set
        } else {
          error.splice(i, 1)
        }
      })
    },
    // 開始予定の空文字チェック
    plan_start_empty: function () {
      let error = this.planStartEmpty
      this.plan_start.forEach((value, i, array) => {
        if (((this.task[i] !== "") || (this.plan_day[i] !== "") || (this.progress[i] !== "") || (this.start_day[i] !== "") || (this.plan_end[i] !== "") || (this.end_day[i] !== "")) && (array[i] === "")) {
          error.splice(i, 1, i + 1 + 'つ目の開始予定を入力してください ')
          let set = Array.from(new Set(error))
          error = set
        } else {
          error.splice(i, 1)
        }
      })
    },
    // 開始日の空文字チェック
    start_day_empty: function () {
      let error = this.startDayEmpty
      this.start_day.forEach((value, i, array) => {
        if (((this.task[i] !== "") || (this.plan_day[i] !== "") || (this.progress[i] !== "") || (this.plan_start[i] !== "") || (this.plan_end[i] !== "") || (this.end_day[i] !== "")) && (array[i] === "")) {
          error.splice(i, 1, i + 1 + 'つ目の開始日を入力してください ')
          let set = Array.from(new Set(error))
          error = set
        } else {
          error.splice(i, 1)
        }
      })
    },
    // 完了予定の空文字チェック
    plan_end_empty: function () {
      let error = this.planEndEmpty
      this.plan_end.forEach((value, i, array) => {
        if (((this.task[i] !== "") || (this.plan_day[i] !== "") || (this.progress[i] !== "") || (this.start_day[i] !== "") || (this.plan_start[i] !== "") || (this.end_day[i] !== "")) && (array[i] === "")) {
          error.splice(i, 1, i + 1 + 'つ目の完了予定を入力してください ')
          let set = Array.from(new Set(error))
          error = set
        } else {
          error.splice(i, 1)
        }
      })
    },
    // 完了日の空文字チェック
    end_day_empty: function () {
      let error = this.endDayEmpty
      this.end_day.forEach((value, i, array) => {
        if (((this.task[i] !== "") || (this.plan_day[i] !== "") || (this.progress[i] !== "") || (this.start_day[i] !== "") || (this.plan_start[i] !== "") || (this.end_day[i] !== "")) && (array[i] === "")) {
          error.splice(i, 1, i + 1 + 'つ目の完了予定を入力してください ')
          let set = Array.from(new Set(error))
          error = set
        } else {
          error.splice(i, 1)
        }
      })
    },
    // 配列以外の空文字チェック
    string_empty: function (errors, name, message) {
      let error = errors
      if (name === "") {
        error.splice(0, 1, message)
        let set = Array.from(new Set(error))
        error = set
      } else {
        error.splice(0, 1)
      }
    },
    // 時間の入力形式チェック
    time_regex: function (errors, name, message) {
      let error = errors
      if ((name !== "") && (!name.match(/^\d{1,3}:\d{2}$/))) {
        error.splice(0, 1, message)
        let set = Array.from(new Set(error))
        error = set
      } else {
        error.splice(0, 1)
      }
    },
    // 作業内容の空文字チェック
    details_empty: function (errors, name, message) {
      this.string_empty(
        errors = this.detailsEmpty,
        name = this.details,
        message = '作業内容を入力してください'
      )
    },
    // 問題点の空文字チェック
    problem_empty: function (errors, name, message) {
      this.string_empty(
        errors = this.problemEmpty,
        name = this.problem,
        message = '問題点を入力してください'
      )
    },
    // 原因の空文字チェック
    cause_empty: function (errors, name, message) {
      this.string_empty(
        errors = this.causeEmpty,
        name = this.cause,
        message = '原因を入力してください'
      )
    },
    // 対策の空文字チェック
    measure_empty: function (errors, name, message) {
      this.string_empty(
        errors = this.measureEmpty,
        name = this.measures,
        message = '対策を入力してください'
      )
    },
    // 勤務時間の空文字チェック
    total_time_empty: function (errors, name, message) {
      this.string_empty(
        errors = this.totalTimeEmpty,
        name = this.total_time,
        message = '勤務時間を入力してください'
      )
    },
    // 勤務時間の入力形式チェック
    total_time_regex: function (errors, name, message) {
      this.time_regex(
        errors = this.totalTimeRegex,
        name = this.total_time,
        message = '勤務時間は入力例のように、半角数字と記号を用いて入力してください'
      )
    },
    // 規定勤務時間の空文字チェック
    defined_empty: function (errors, name, message) {
      this.string_empty(
        errors = this.definedEmpty,
        name = this.defined,
        message = '規定勤務時間を入力してください'
      )
    },
    // 規定勤務時間の入力形式チェック
    defined_regex: function (errors, name, message) {
      this.time_regex(
        errors = this.definedRegex,
        name = this.defined,
        message = '規定勤務時間は入力例のように、半角数字と記号を用いて入力してください'
      )
    },
    // 予定時間外勤務時間の空文字チェック
    expect_over_empty: function (errors, name, message) {
      this.string_empty(
        errors = this.expectOverEmpty,
        name = this.expect_over,
        message = '予定時間外勤務時間を入力してください'
      )
    },
    // 予定時間外勤務時間の入力形式チェック
    expect_over_regex: function (errors, name, message) {
      this.time_regex(
        errors = this.expectOverRegex,
        name = this.expect_over,
        message = '予定時間外勤務時間は入力例のように、半角数字と記号を用いて入力してください'
      )
    },
    // 時間外勤務時間の空文字チェック
    total_over_empty: function (errors, name, message) {
      this.string_empty(
        errors = this.totalOverEmpty,
        name = this.total_over,
        message = '時間外勤務時間を入力してください'
      )
    },
    // 時間外勤務時間の入力形式チェック
    total_over_regex: function (errors, name, message) {
      this.time_regex(
        errors = this.totalOverRegex,
        name = this.total_over,
        message = '時間外勤務時間は入力例のように、半角数字と記号を用いて入力してください'
      )
    },
    // 夜勤勤務時間の空文字チェック
    total_night_empty: function (errors, name, message) {
      this.string_empty(
        errors = this.totalNightEmpty,
        name = this.total_night,
        message = '夜勤勤務時間を入力してください'
      )
    },
    // 夜勤勤務時間の入力形式チェック
    total_night_regex: function (errors, name, message) {
      this.time_regex(
        errors = this.totalNightRegex,
        name = this.total_night,
        message = '夜勤勤務時間は入力例のように、半角数字と記号を用いて入力してください'
      )
    },
    // 休日勤務時間の空文字チェック
    total_holiday_empty: function (errors, name, message) {
      this.string_empty(
        errors = this.totalHolidayEmpty,
        name = this.total_holiday,
        message = '休日勤務時間を入力してください'
      )
    },
    // 休日勤務時間の入力形式チェック
    total_holiday_regex: function (errors, name, message) {
      this.time_regex(
        errors = this.totalHolidayRegex,
        name = this.total_holiday,
        message = '休日勤務時間は入力例のように、半角数字と記号を用いて入力してください'
      )
    },
    // 時間外作業発生理由の空文字チェック
    over_reason_empty: function (errors, name, message) {
      if ((this.expect_over == "") || (this.expect_over == "00:00")) return;
      this.string_empty(
        errors = this.overReasonEmpty,
        name = this.over_reason,
        message = '時間外作業発生理由を入力してください'
      )
    }
  }
}
</script>

<style scoped>

</style>
